import { render } from "./Loading.vue?vue&type=template&id=98c030b2"
import script from "./Loading.vue?vue&type=script&lang=js"
export * from "./Loading.vue?vue&type=script&lang=js"
script.render = render

export default script